import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import * as maplayerAction from "../../../infofleet/ducks/maplayer";
import {
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";
import MapIcon from "@mui/icons-material/Map";
import InformapMapIcon from "../../../assets/infofleet/informap_maps.png";
import GoogleMapIcon from "../../../assets/infofleet/google-maps.png";
import api from "../../router/axiosConfig";

function MapActionsPanel({ maplayer }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLayer, setSelectedLayer] = useState("informap");
  const dispatch = useDispatch();

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleMapSelect = (type) => {
    dispatch(maplayerAction.actions.ClusterView(false));
    dispatch(maplayerAction.actions.MapLayer(type));
    setSelectedLayer(type);
    handleCloseMenu();
  };

  useEffect(() => {
    const fetchMapList = async () => {
      try {
        const response = await api.get("getCustomerMapList");
        // const googleMapData = response.data?.filter((item) => item.id === 2);
        // if (googleMapData?.length > 0 && googleMapData[0].isDefault === true) {
        //   handleMapSelect("google");
        // }
        const googleMapData = response?.data?.filter((item) => item?.defaultMap === true);
        if (googleMapData?.length > 0 && googleMapData[0]?.isDefault === true && googleMapData[0]?.name === "Google") {
          handleMapSelect("google");
        }
      } catch (error) {
        console.error("Error fetching map list:", error);
      }
    };

    fetchMapList();
  }, []);

  return (
    <>
      <Tooltip
        title={
          <Box fontSize={10} textAlign="left">
            <strong>Map Layer : </strong>Switch Map Source. Advised to use Google map sparingly, as it is not Free!
          </Box>
        }
        placement="bottom"
        arrow
        slotProps={{
          tooltip: {
            sx: {
              bgcolor: '#fff',
              color: '#000',
              fontSize: 14,
              borderRadius: 1,
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
            },
          },
        }}
      >
        <IconButton onClick={handleOpenMenu} size="small">
          <MapIcon style={{ color: "#007bff" }} fontSize="large" />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        PaperProps={{
          style: {
            minWidth: 180,
            padding: "10px",
          },
        }}
      >
        <Typography variant="subtitle1" style={{ padding: "8px 12px", fontWeight: 600 }}>
          Select Map
        </Typography>

        <MenuItem onClick={() => handleMapSelect("informap")}>
          <Box display="flex" alignItems="center">
            <img
              src={InformapMapIcon}
              alt="Informap"
              style={{
                width: 35,
                height: 35,
                marginRight: 10,
                borderRadius: 5,
                border:
                  selectedLayer === "informap"
                    ? "2px solid #007bff"
                    : "1px solid #ccc",
              }}
            />
            <Typography
              fontWeight={selectedLayer === "informap" ? "600" : "400"}
            >
              Informap
            </Typography>
          </Box>
        </MenuItem>

        <MenuItem onClick={() => handleMapSelect("google")}>
          <Box display="flex" alignItems="center">
            <img
              src={GoogleMapIcon}
              alt="Google"
              style={{
                width: 35,
                height: 35,
                marginRight: 10,
                borderRadius: 5,
                border:
                  selectedLayer === "google"
                    ? "2px solid #007bff"
                    : "1px solid #ccc",
              }}
            />
            <Typography
              fontWeight={selectedLayer === "google" ? "600" : "400"}
            >
              Google
            </Typography>
          </Box>
        </MenuItem>
      </Menu>
    </>
  );
}

const mapStateToProps = ({ maplayer }) => ({
  maplayer,
});

export default connect(mapStateToProps, { maplayerAction })(MapActionsPanel);
